import { UmssDialogComponent } from './../dialog/dialog.component';
import { Component, input, signal } from '@angular/core';
import { UmssButtonComponent } from '../button/button.component';
import { NgTemplateOutlet } from '@angular/common';
import { UmssDialogHeaderComponent } from '../dialog-header/dialog-header.component';

@Component({
  selector: 'umss-pay-flow-info',
  imports: [
    UmssDialogComponent,
    UmssButtonComponent,
    NgTemplateOutlet,
    UmssDialogHeaderComponent
  ],
  templateUrl: './pay-flow-info.component.html',
  styleUrl: './pay-flow-info.component.scss'
})
export class UmssPayFlowInfoComponent {
  type = input.required<'payer' | 'receiver'>();
  container = input<'dialog' | 'card'>('card');

  flowInfo: Record<'payer' | 'receiver', string[]> = {
    payer: [
      'Weekly pay period is Monday - Sunday',
      'You can approve time sheets during the pay period and 3 days after until the end of Wednesday of the following week.',
      'Your invoice will be generated the next day, on the Thursday. You have 9 days to pay the invoice until the end of the next Friday',
      'After that Friday the contractor will be paid within the week.'
    ],
    receiver: [
      'Weekly pay period is Monday - Sunday',
      'Facilities have 2 weeks to process time sheets.',
      'You will be paid by Friday, on the 3rd week.'
    ]
  };

  isOpen = signal(false);

  openDialog() {
    this.isOpen.set(true);
  }

  closeDialog() {
    this.isOpen.set(false);
  }
}
